import { Injectable } from '@angular/core';

import {
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  HTTP_HEADERS,
  IDP_APP,
  MyTripEndpointKeys
} from '../models/enums/my-trip.enums';
import { GenericFormFields } from '../models/interface/generic-form.interface';

@Injectable({
  providedIn: 'root'
})
export class ViewTripDetailsService {
  timeout!: number;
  myTripsHeader: HttpHeadersPayload = {
    'Content-Type': HTTP_HEADERS.CONTENT_TYPE,
    appId: HTTP_HEADERS.APP_ID,
    channelId: HTTP_HEADERS.CHANNEL_ID,
    purchasePath: HTTP_HEADERS.PURCHASE_PATH
  };

  loadViewTripDetailsForm = false;
  viewTripDetailsPath!: string;
  viewTripDetailsFormFields: GenericFormFields = {
    fieldItem: [],
    action: '',
    target: '',
    method: HttpRequestMethods.POST
  } as GenericFormFields;

  constructor(private appConfig: AppConfigService) {
    this.appConfig
      .getConfigValue(IDP_APP.MY_TRIPS, MyTripEndpointKeys.FIND_PNR)
      .subscribe((value: string) => {
        this.viewTripDetailsPath = value;
      });
  }

  addFormField(key: string, value: string | boolean): void {
    this.viewTripDetailsFormFields.fieldItem.push({ key: key, value: value });
  }
}
